import { isAttr,jsonClone } from '../utils';
import childrenItem from './slot/index';
import {remoteData} from './mixin';
import Vue from 'vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"

function vModel(self, dataObject) {
  dataObject.props.value=self.value;
  dataObject.on.input = val => {
    self.$emit('input', val)
  }
  //判断是否为上传组件
  if(self.conf.compType === 'upload'){
    dataObject.attrs['data'] = {biz:'temp'};
    // add by nbacheng 2022-09-09
    const token = Vue.ls.get(ACCESS_TOKEN);
    dataObject.attrs['headers'] = {"X-Access-Token":token};
    if (dataObject.props.value != '') {
      const filevalue = JSON.parse(dataObject.props.value);
      filevalue.map(f=>{
        f.url = window._CONFIG['staticDomainURL'] + '/' + f.url;
      });
      dataObject.props['file-list'] = filevalue;
    }
    dataObject.attrs['on-preview'] = (file) => {
      window.open(file.url, "_blank")
    }
  }  
}

export default {
  render(h) {
    let dataObject = {
      attrs: {},
      props: {},
      on: {},
      style: {}
    }

    //远程获取数据
    this.getRemoteData();
    const confClone = jsonClone(this.conf);
    const children = childrenItem(h,confClone);   
    // 如果需要token，可以设置
    const token = Vue.ls.get(ACCESS_TOKEN);
    confClone['headers'] = {"X-Access-Token":token};
    Object.keys(confClone).forEach(key => {
      const val = confClone[key]
      if (dataObject[key]) {
        dataObject[key] = val
      } else if(key ==='width'){
        dataObject.style= 'width:'+val+'%';
      } else if (!isAttr(key)) {
        dataObject.props[key] = val
      } else {
        dataObject.attrs[key] = val
      }
    })
    /*调整赋值模式，规避cascader组件赋值props会出现覆盖预制参数的bug */
    vModel(this, dataObject);
    if(dataObject.props['list-type'] == "picture-card"){
      dataObject.scopedSlots = {
        file: (props) => {
          let _this = this;
          return h(
            'div',
            { class: 'el-upload-list__item' },
            [
              h('img', {
                class: 'el-upload-list__item-thumbnail',
                attrs: {
                  src: props.file.url,
                  alt: props.file.name
                }
              }),
              h(
                'span',
                { class: 'el-upload-list__item-actions' },
                [
                  h(
                    'span',
                    {
                      class: 'el-upload-list__item-preview',
                      on: {
                        click: () => {
                            let file = props.file;
                            // window.open(file.response.message, "_blank")
                            // window.open(file.url, "_blank")
                            var body = document.getElementsByTagName('body');
                            body[0].style.overflowY = 'hidden';
                            var dialog = document.createElement('div');
                            dialog.id = 'img-dialog';
                            dialog.style.position = 'absolute';
                            dialog.style.top = '0';
                            dialog.style.right = '0';
                            dialog.style.left = '0';
                            // dialog.style.bottom = '0';
                            dialog.style.margin = '30px 400px';
                            // dialog.style.width = '520px';
                            // dialog.style.height = '500px';
                            dialog.style.background = '#fff';
                            dialog.style.padding = '24px';
                            dialog.style.borderRadius = '5px';
                            var span = document.createElement('span');
                            span.innerHTML = "x";
                            span.style.position = 'absolute';
                            span.style.top = '0px';
                            span.style.right = '8px';
                            span.style.fontSize = '25px';
                            span.style.cursor = 'pointer';
                            span.onclick = ()=>{
                              mask.style.display = 'none';
                              body[0].style.overflowY = 'auto';
                            }
                            var img = document.createElement('img');
                            img.src = file.url;
                            img.style.width = '100%';
                            // img.style.height = '100%';
                            img.style.maxHeight = '620px';
                            img.style.border = '1px solid #eee';
                            var mask = document.createElement('div');
                            mask.style.display = 'block';
                            mask.style.width = '100%';
                            mask.style.height = '100%';
                            mask.style.position = 'fixed';
                            mask.style.top = '0';
                            mask.style.zIndex = 999;
                            mask.style.backgroundColor = 'rgba(0,0,0,.45)';
                            var download = document.createElement('button');
                            download.innerHTML = "下载";
                            download.style.position = 'absolute';
                            download.style.bottom = '-10px';
                            download.style.right = '0';
                            download.style.left = '0';
                            download.style.margin = 'auto';
                            download.style.width = '100px';
                            download.style.height = '30px';
                            download.style.background = '#409EFF';
                            download.style.color = '#fff';
                            download.style.border = 'none';
                            download.style.borderRadius = '5px';
                            download.style.cursor = 'pointer';
                            download.onclick = ()=>{
                              window.open(file.url, "_blank")
                            }
                            dialog.appendChild(span);
                            dialog.appendChild(img);
                            dialog.appendChild(download);
                            mask.appendChild(dialog);
                            document.body.appendChild(mask);
                          }
                        }
                    },
                    [
                      h('i', { class: 'el-icon-zoom-in' })
                    ]
                  ),
                  !props.disabled && h(
                    'span',
                    {
                      class: 'el-upload-list__item-delete',
                      on: {
                        click: () => {
                          let file = props.file;
                          window.open(file.url, "_blank")
                        }
                      }
                    },
                    [
                      h('i', { class: 'el-icon-download' })
                    ]
                  ),
                  !props.disabled && h(
                    'span',
                    {
                      class: 'el-upload-list__item-delete',
                      on: {
                        click: () => {
                          let file = props.file;
                          let oldValue = JSON.parse(dataObject.props.value);
                          let newValue = oldValue.filter(item => item.name !== file.name)
                          _this.$emit('input',JSON.stringify(newValue));
                        }
                      }
                    },
                    [
                      h('i', { class: 'el-icon-delete' })
                    ]
                  )
                ]
              )
            ]
          );
        }
      }
    }
    return h(confClone.ele, dataObject, children)
  },
  props: ['conf','value'],
  mixins:[remoteData]
}
